import { memo } from 'react';
import { RecoilRoot } from 'recoil';
import { StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import IntlProvider from '@i18n/IntlProvider';
import ReactNativeProvider from '@components/ReactNativeProvider';
import { RecoilExternalStatePortal } from '@utils/recoil/RecoilExternalStatePortal';
import theme from '@theme/mui';
import ToastContainer from '@molecules/toastContainer/ToastContainer';

export interface AppWrapperProps {
    children: React.ReactNode;
}

const AppWrapper = ({ children }: AppWrapperProps) => (
    <IntlProvider>
        <RecoilRoot>
            <RecoilExternalStatePortal />
            <StylesProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <ReactNativeProvider>
                        <ToastContainer />
                        <CssBaseline />
                        {children}
                    </ReactNativeProvider>
                </ThemeProvider>
            </StylesProvider>
        </RecoilRoot>
    </IntlProvider>
);

export default memo(AppWrapper);
